export const clearIndexedDBs = async () => {
    const hasIndexedDb = "indexedDB" in window;
    if (!hasIndexedDb) {
        return;
    }

    const hasDatabasesMethod = typeof window.indexedDB.databases === "function";
    if (!hasDatabasesMethod) {
        return;
    }

    const dbs = await window.indexedDB.databases();
    const deletePromises = dbs.map((db) => {
        if (!db.name) {
            return Promise.resolve();
        }

        return new Promise<void>((resolve) => {
            const request = window.indexedDB.deleteDatabase(db.name as string);

            request.onsuccess = () => {
                resolve();
            };
            request.onerror = () => {
                resolve();
            };
            request.onblocked = () => {
                resolve();
            };
        });
    });

    await Promise.all(deletePromises);
};